import { render, staticRenderFns } from "./GenderMobility.vue?vue&type=template&id=0dd36b70&scoped=true"
import script from "./GenderMobility.vue?vue&type=script&lang=js"
export * from "./GenderMobility.vue?vue&type=script&lang=js"
import style0 from "./GenderMobility.vue?vue&type=style&index=0&id=0dd36b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd36b70",
  null
  
)

export default component.exports